import { Flex } from 'antd'
import type { CSSProperties, ReactNode } from 'react'

import { useStyles } from './styles'

type Props = {
  left: ReactNode
  right: ReactNode
  className?: string
  style?: CSSProperties
}

/**
 * Canonical toolbar row for card-backed list/detail surfaces. Centralises the
 * shared padding, border, and slot spacing so pages keep one consistent shell.
 */
export const CardToolbarRow = ({ left, right, className, style }: Props) => {
  const { styles, cx } = useStyles()

  return (
    <div className={cx(styles.root, className)} style={style}>
      <Flex justify="space-between" align="center" gap={10} wrap="wrap">
        <Flex align="center" gap={8} wrap="wrap" className={styles.left}>
          {left}
        </Flex>
        <Flex align="center" gap={8} wrap="wrap" className={styles.right}>
          {right}
        </Flex>
      </Flex>
    </div>
  )
}
